import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {PROPOSITION_BETS} from "../../widgets/proposition-bets-widget/proposition-bets-widgets.consts";

export class PropositionBetsPopupDisplayHandler extends AnalyticsEventHandler {
  type: String = PROPOSITION_BETS.ACTION_TYPES.onPopupClick;

  async action(params) {
    if(params && !this.state.appState.settings.isWidget) {
      this.state.popupDisplay.athleteId = params?.athleteId;
      this.state.popupDisplay.lineTypeId = params?.lineTypeId;
      this.state.popupDisplay.gameId = params?.gameId;
    } else {
      this.state.popupDisplay?.clear();
    }
  }
}
